<ion-header [hidden]="globals.NoTopBar" style="min-height: 65px">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button auto-hide="true" menu="LeftMenu"></ion-menu-button>
    </ion-buttons>
    <ion-title>
      <ion-title>{{
        globals != null ? globals.ContentPageTitle : ""
      }}</ion-title>
    </ion-title>

    <div
      style="
        position: absolute;
        top: 0px;
        right: 0px;
        background-color: transparent;
      "
    >
      <ion-list>
        <ion-row>
          <ion-col
            *ngIf="
              !authenticationService.offlineAuthenticated &&
              PercentageDownloaded >= 100 &&
              OnLine
            "
            title="Finished Downloading Content"
            class="numberCircleComplete"
          >
            <span>100%</span>
          </ion-col>

          <ion-col
            size="auto"
            [title]="
              this.globals.XRSUser != null ? this.globals.XRSUser.Site_Name : ''
            "
          >
            <!-- <ion-item> -->
            <ion-chip>
              <ion-avatar>
                <!-- <img
                  alt="Silhouette of a person's head"
                  src="https://ionicframework.com/docs/img/demos/avatar.svg"
                /> -->
                <img
                  alt="User's profile"
                  src="assets/CustomContent/Thumbnails/user_blank.jpg"
                />
                <!-- <img
                  alt="User's profile"
                  [src]="
                    getImageSrc(
                      this.globals.XRSUser?.Picture_ContentGUID,
                      'user_blank.jpg'
                    )
                  "
                  (error)="globals.onThumbnailError($event, 'user_blank.jpg')"
                /> -->
              </ion-avatar>
              <button
                ion-button
                style="
                  background-color: transparent;
                  color: white;
                  text-decoration: underline;
                "
              >
                <!-- {{
                  this.globals.XRSUser != null
                    ? this.globals.XRSUser.Site_Name
                    : ""
                }}
                - -->
                {{
                  this.globals.XRSUser != null
                    ? this.globals.XRSUser.Firstname
                    : ""
                }}
                {{
                  this.globals.XRSUser != null
                    ? this.globals.XRSUser.Surname
                    : ""
                }}
              </button>
            </ion-chip>
            <!-- </ion-item> -->
          </ion-col>

          <!-- Limit Info button to only display to admin/facilitator users -->

          <ion-col
            size="auto"
            id="step5"
            *ngIf="
              globals.XRSUser?.Role_GUID !=
              'fda14765-e176-a57c-59f1-0353f576a36a'
            "
          >
            <ion-item (click)="openModal()">
              <ion-tab-button>
                <ion-icon name="information-circle-outline"></ion-icon>
                {{ globals != null ? globals.ContentPageTitle : "" }}
              </ion-tab-button>
            </ion-item>
          </ion-col>

          <ion-col size="auto" id="step2">
            <ion-item>
              <ion-tab-button (click)="notificationModal()">
                <ion-icon name="notifications-circle-outline"></ion-icon>
                <ion-badge *ngIf="showBadge"></ion-badge>
                What's new
              </ion-tab-button>
            </ion-item>
          </ion-col>

          <ion-col
            *ngIf="
              !authenticationService.offlineAuthenticated &&
              this.globals.OfflineEnabled == true
            "
          >
            <ion-item>
              <ion-label>{{ enablingOffline }} - {{ OnLine }}</ion-label>
              <br />
              <ion-button
                disabled="{{ enablingOfflineButton || !OnLine }}"
                (click)="enableOffline()"
                >Enable Offline {{ lastUpdate | date : "short" }}</ion-button
              >
            </ion-item>
          </ion-col>

          <ion-col title="Status" class="status">
            <div *ngIf="OnLine" class="online">
              <ion-icon name="cloud" class="cloud"></ion-icon>
              <span>Online</span>
            </div>
            <span
              *ngIf="
                !OnLine &&
                !authenticationService.offlineAuthenticated &&
                PercentageDownloaded > 0 &&
                this.globals.OfflineEnabled
              "
              class="numberCircle"
              >{{ PercentageDownloaded }}%</span
            >
            <div
              *ngIf="!authenticationService.offlineAuthenticated && !OnLine"
              class="offline"
            >
              <ion-icon name="cloud-offline" class="Off-cloud"></ion-icon
              ><span>Offline</span>
            </div>
          </ion-col>
          <ion-col>
            <ion-item style="padding-left: 18px">
              <ion-buttons>
                <!-- <ion-button
                  *ngIf="!globals.isFullScreen"
                  (click)="globals.toggleFullScreen(true)"
                  size="large"
                >
                  <ion-icon name="stop-outline"></ion-icon>
                </ion-button>
                <ion-button
                  *ngIf="globals.isFullScreen"
                  (click)="globals.toggleFullScreen(false)"
                  size="large"
                >
                  <ion-icon name="copy-outline"></ion-icon>
                </ion-button> -->

                <ion-button
                  *ngIf="!globals.isFullScreen"
                  (click)="globals.toggleFullScreen(true)"
                  size="large"
                  title="Fullscreen"
                >
                  <ion-icon name="scan-outline"></ion-icon>
                </ion-button>
                <ion-button
                  *ngIf="globals.isFullScreen"
                  (click)="globals.toggleFullScreen(false)"
                  size="large"
                  title="Minimise"
                >
                  <ion-icon name="contract-outline"></ion-icon>
                </ion-button>
              </ion-buttons>

              <!-- <ion-toggle
                [ngModel]="globals.isFullScreen"
                (ngModelChange)="
                  globals.toggleFullScreen(!globals.isFullScreen)
                "
              ></ion-toggle>
              <ion-label>Fullscreen</ion-label> -->
            </ion-item>
          </ion-col>
          <ion-col>
            <ion-item>
              <ion-button (click)="logOut()"
                ><ion-icon name="log-out-outline"></ion-icon>Log out</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-list>
    </div>

    <ion-buttons slot="end">
      <ion-menu-button menu="RightMenu"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
